import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { SERVICES, scrollToSection } from "./data";

const Services = () => (
  <section id="services" data-testid="services-section" className="relative bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHead num="01" eyebrow="What we do" title="Professional Painting Services" testid="services-head" />
        <Reveal delay={0.15} className="max-w-sm">
          <p className="text-sm leading-relaxed text-slate-500 sm:text-base">
            A painting company Reno NV homeowners and businesses trust — from single rooms to full commercial properties.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-6">
        {SERVICES.map(({ icon: Icon, slug, title, desc }, i) => (
          <Reveal key={slug} delay={i * 0.07} className={i < 3 ? "lg:col-span-2" : "lg:col-span-3"}>
            <article
              data-testid={`service-card-${slug}`}
              className="group relative h-full overflow-hidden rounded-2xl border border-slate-200 bg-white p-8 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/50 hover:shadow-[0_26px_54px_-22px_rgba(11,25,44,0.28)]"
            >
              <span
                aria-hidden="true"
                className="absolute right-6 top-5 font-mono text-sm tracking-widest text-slate-200 transition-colors duration-300 group-hover:text-gold/60"
              >
                0{i + 1}
              </span>
              <span
                aria-hidden="true"
                className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gradient-to-r from-gold to-gold-muted transition-transform duration-500 group-hover:scale-x-100"
              />
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
                <Icon size={22} strokeWidth={1.8} />
              </div>
              <h3 className="mt-6 text-[15px] font-extrabold tracking-[0.1em] text-navy">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">{desc}</p>
              <button
                data-testid={`service-card-${slug}-cta`}
                onClick={() => scrollToSection("#contact")}
                className="mt-6 inline-flex items-center gap-2 text-[12px] font-extrabold tracking-[0.16em] text-navy transition-colors group-hover:text-gold-muted"
              >
                GET A FREE ESTIMATE
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
